"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePageScrollRestore = void 0;
const react_1 = require("react");
const router_1 = require("next/router");
function getPageEle() {
    return document.querySelectorAll('.j-app .j-page')[0];
}
// needed for proper iOS backswipe gesture
function usePageScrollRestore() {
    const router = router_1.useRouter();
    const retainedPagesRef = react_1.useRef({});
    const prevUrlRef = react_1.useRef(router.asPath);
    react_1.useEffect(() => {
        const handleRouteChangeStart = (url) => {
            if (!getPageEle()) {
                return;
            }
            retainedPagesRef.current[prevUrlRef.current] = {
                scrollTop: getPageEle().scrollTop,
            };
            prevUrlRef.current = url;
        };
        const handleRouteComplete = (url) => {
            const retainedPage = retainedPagesRef.current[url];
            if (retainedPage && getPageEle()) {
                getPageEle().scrollTo(0, retainedPage.scrollTop);
            }
        };
        router.events.on('routeChangeStart', handleRouteChangeStart);
        router.events.on('routeChangeComplete', handleRouteComplete);
        return () => {
            router.events.off('routeChangeStart', handleRouteChangeStart);
            router.events.off('routeChangeComplete', handleRouteComplete);
        };
    }, [router.events]);
    return retainedPagesRef;
}
exports.usePageScrollRestore = usePageScrollRestore;
